define("settings/components/downgrade/team-member", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td>
      <div class="u--block u--clearfix dd-privacy-mask-user-input">
        <div class="u--float--left {{if (find-by 'id' @teamMember.id @teamMembersToRemove) 'u--mute u--text--strike'}}">
          <p class="u--text--md u--m__0">{{@teamMember.name}}</p>
          <span>{{@teamMember.email}}</span>
        </div>
  
        {{#if (find-by "id" @teamMember.id @teamMembersToRemove)}}
          <Shared::Ui::Button
            @onClick={{@restoreTeamMember}}
            @text={{t "account.downgrade.team_members.restore"}}
            @variant="mute"
            class="u--float--right"
            data-test-id="restore-user"
          />
        {{else}}
          <Shared::Ui::Button
            @onClick={{@removeTeamMember}}
            @text={{t "shared_words.remove"}}
            @variant="mute"
            class="u--float--right"
            data-test-id="remove-user"
          />
        {{/if}}
      </div>
    </td>
  </tr>
  */
  {
    "id": "zpaweSWw",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--block u--clearfix dd-privacy-mask-user-input\"],[12],[1,\"\\n      \"],[10,0],[15,0,[29,[\"u--float--left \",[52,[28,[37,1],[\"id\",[30,1,[\"id\"]],[30,2]],null],\"u--mute u--text--strike\"]]]],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__0\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n        \"],[10,1],[12],[1,[30,1,[\"email\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[28,[37,1],[\"id\",[30,1,[\"id\"]],[30,2]],null],[[[1,\"        \"],[8,[39,2],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"restore-user\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,3],[28,[37,3],[\"account.downgrade.team_members.restore\"],null],\"mute\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,2],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"remove-user\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,4],[28,[37,3],[\"shared_words.remove\"],null],\"mute\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@teamMember\",\"@teamMembersToRemove\",\"@restoreTeamMember\",\"@removeTeamMember\"],false,[\"if\",\"find-by\",\"shared/ui/button\",\"t\"]]",
    "moduleName": "settings/components/downgrade/team-member.hbs",
    "isStrictMode": false
  });
  const TeamMemberComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TeamMemberComponent);
});